import { Schema } from "effect";

/**
 * Error when cabin configuration is invalid.
 */
export class InvalidConfigurationError extends Schema.TaggedError<
  InvalidConfigurationError
>()("InvalidConfigurationError", {
  message: Schema.String,
  field: Schema.String,
}) {}

/**
 * Error when lap infants exceed economy passengers.
 */
export class LapInfantExceedsPassengersError extends Schema.TaggedError<
  LapInfantExceedsPassengersError
>()("LapInfantExceedsPassengersError", {
  lapInfants: Schema.Number,
  economyPassengers: Schema.Number,
}) {}

/**
 * Error when cabin is overbooked.
 */
export class OverbookingError extends Schema.TaggedError<OverbookingError>()(
  "OverbookingError",
  {
    totalPassengers: Schema.Number,
    availableSeats: Schema.Number,
    overbookedBy: Schema.Number,
  }
) {}

/**
 * Union of all domain errors.
 */
export type DomainError =
  | InvalidConfigurationError
  | LapInfantExceedsPassengersError
  | OverbookingError;
